import { getValueFromSearchParams, isIn3D } from '@/utils';
import { useState, useCallback, useRef, useEffect } from 'react'
import { lang } from '@/locales'
import { useSessionStorageState } from 'ahooks';
import { postIframePlaceholderToExpand, isInIframe } from '@/hooks';
import { sunvegaAPI } from 'utils';
export const materialSource = ['建E', '欧模']
export const isOversea = (!getValueFromSearchParams('oversea') && !!lang && lang !== 'zh-CN') || window.location.hostname.indexOf('aihouse') > -1 || !!(getValueFromSearchParams('oversea') && getValueFromSearchParams('oversea') === 'true');
type MenuNames = {
  [key: string]: string;
};

// 窗口 resize 相关的模块级变量
let expandResizeLock = false

// 导出访问函数
export const getExpandResizeLock = () => expandResizeLock
export const setExpandResizeLock = (value: boolean) => {
  expandResizeLock = value
}

export default () => {
  /**
   * 断点值，小屏幕临界点
   * @constant {number}
  */
  const breakpoint = 800;
  /**
   * des app是否处于小屏幕状态
   * @type {[boolean, React.Dispatch<React.SetStateAction<boolean>]}
  */
  const [isMin, setIsMin1] = useState(isInIframe)
  // 包装一下setIsMin
  const setIsMin = useCallback((val: boolean) => {
    setIsMin1(isInIframe)
  }, [])
  /* 是否海外 */
  /* 是否显示折叠按钮 */
  const [isShowBtn, setIsShowBtn] = useState(false)

  /*  */
  const [isCollapse, setIsCollapse] = useState(isIn3D)
  /* 二三级菜单数据map */
  const [leftSiderSubMap, setLeftSiderSubMap] = useSessionStorageState<any>(
    'use-session-storage-state-gobal-menus',
    {
      defaultValue: {}
    },
  )
  // 下拉的数据key对应组合
  const [selectMaps, setsessionSelectMaps] = useSessionStorageState<any>(
    'use-session-storage-state-select-maps',
    {
      defaultValue: {}
    },
  );
  /* 不同尺寸的样式设置 */
  interface GlobalStyles {
    width: number;
    margin: number;
    boxMargin: number;
  }
  const [globalStyles, setGlobalStyles] = useState<GlobalStyles>({
    width: 128,
    margin: 6,
    boxMargin: 16
  })
  const [list, toggleSetList] = useState<any>([]);
  const setList = useCallback((val: any) => toggleSetList(val), [])
  /* 创建一个随机字符串state */
  const [shouldLoadList, setShouldLoadList] = useState<string>('')
  const shouldLoadListRef = useRef('')
  const toggleShouldLoadList = useCallback((val: any) => {
    setShouldLoadList(val)
    shouldLoadListRef.current = val
  }, [])
  /* loading setLoading */
  const [loading, setLoading] = useState(true)
  const [imageSearchSourceLoading, setImageSearchSourceLoading] = useState(false)
  /* 热词 */
  const [hotWord, setHotWord] = useState<string>('')

  const [showCustomTagBox, toggleShowCustomTagBox] = useState<boolean>(false)
  const showCustomTagBoxRef = useRef(false)
  const setShowCustomTagBox = useCallback((val: any) => {
    toggleShowCustomTagBox(val)
    showCustomTagBoxRef.current = val
  }, [])
  const [isShowNoResult, setIsShowNoResult] = useState(false)
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const [menuNames, setMenuNames] = useSessionStorageState<MenuNames>(
    'use-session-storage-state-menu-names',
    {
      defaultValue: {}
    },
  );
  const [menuOptions, setMenuOptions] = useSessionStorageState<any>(
    'use-session-storage-state-menu-options',
    {
      defaultValue: {}
    },
  );
  const [fullPathMap, setFullPathMap] = useSessionStorageState<any>(
    'use-session-storage-state-full-path-map',
    {
      defaultValue: {}
    },
  );
  const [page_title, setPage_title] = useState('模型');
  const isScrollRef = useRef(false)
  /* 是否扩展iframe宽度 */
  const [iframePlaceholderExpand, _setIframePlaceholderExpand] = useState(false);
  // ref
  const iframePlaceholderExpandRef = useRef(false)
  const setIframePlaceholderExpand = (expand: boolean) => {
    if (!sunvegaAPI.isInNewClouddesign()) return;
    iframePlaceholderExpandRef.current = expand
    if (expand) {
      _setIframePlaceholderExpand(expand);
      setTimeout(() => {
        postIframePlaceholderToExpand(expand);
      }, 0);
    } else {
      postIframePlaceholderToExpand(expand);
      setTimeout(() => {
        _setIframePlaceholderExpand(expand);
      }, 0);
    }
  }

  const [isResetIng, setIsReseting] = useState(false)
  // 搜索框建议显隐
  const [searchSuggestVisible, setSearchSuggestVisible] = useState(false);
  // 素材显示模式
  const [directoryMode, setDirectoryMode] = useState(getValueFromSearchParams('directoryMode') || '')
  // GuidanceChannel 组件的渠道代码
  const [guidanceChannelCode, setGuidanceChannelCode] = useState<string>('')
  // HotFilter 组件 GuidanceChannel 的渠道代码
  const [hotFilterGuidanceChannelCode, setHotFilterGuidanceChannelCode] = useState<string>('')
  // 内容宽度
  const [contentWidth, setContentWidth] = useState<number>(404);

  // 设置全局引用，以便在 app.ts 的消息监听中调用
  useEffect(() => {
    (globalThis as any)._setDirectoryMode = setDirectoryMode;
    (globalThis as any).setIframePlaceholderExpand = setIframePlaceholderExpand;
    return () => {
      delete (globalThis as any)._setDirectoryMode;
      delete (globalThis as any).setIframePlaceholderExpand;
    };
  }, [setDirectoryMode]);

  return {
    isMin,
    setIsMin,
    breakpoint,
    isOversea,
    isCollapse,
    isShowBtn,
    setIsShowBtn,
    setIsCollapse,
    leftSiderSubMap,
    setLeftSiderSubMap,
    globalStyles,
    setGlobalStyles,
    list,
    setList,
    shouldLoadList,
    toggleShouldLoadList,
    loading,
    setLoading,
    imageSearchSourceLoading,
    setImageSearchSourceLoading,
    hotWord,
    setHotWord,
    showCustomTagBox,
    setShowCustomTagBox,
    showCustomTagBoxRef,
    isShowNoResult,
    setIsShowNoResult,
    isFirstLoad,
    setIsFirstLoad,
    menuNames,
    setMenuNames,
    shouldLoadListRef,
    selectMaps,
    setsessionSelectMaps,
    page_title,
    setPage_title,
    iframePlaceholderExpand,
    setIframePlaceholderExpand,
    isResetIng,
    setIsReseting,
    iframePlaceholderExpandRef,
    isScrollRef,
    menuOptions,
    setMenuOptions,
    fullPathMap,
    setFullPathMap,
    searchSuggestVisible,
    setSearchSuggestVisible,
    directoryMode,
    setDirectoryMode,
    guidanceChannelCode,
    setGuidanceChannelCode,
    hotFilterGuidanceChannelCode,
    setHotFilterGuidanceChannelCode,
    contentWidth,
    setContentWidth
  }
}
